// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import LinkedOrderDifferences from './linked-order-differences';
import React from 'react';

function LinkedOrderDifferencesPage () {

    return (
        <AuthenticatedPage className="atp-page atp-linked-order-differences-page">
            <LinkedOrderDifferences />
        </AuthenticatedPage>
    );

}
LinkedOrderDifferencesPage.displayNAme = 'LinkedOrderDifferencesPage';

export default LinkedOrderDifferencesPage;
